module.exports = __webpack_public_path__ + "img/calendar.3586effb.svg";